export default "__VITE_ASSET__BAlrC6k0__"